export default     {
    path: 'agents',
    name: 'partnersControl',
    component: () => import(/* webpackChunkName: "PartnersControl" */ '@/views/admin/Control/Partners/PartnersControl.vue'),
    children:[{
            path: 'agent-list',
            name: 'PartnerList',
            component: () => import(/* webpackChunkName: "PartnerList" */ '@/views/admin/Control/Partners/PartnerList.vue'),
        },
        {
            path: 'agent-user',
            name: 'PartnerUser',
            component: () => import(/* webpackChunkName: "PartnerUser" */ '@/views/admin/Control/Partners/PartnerUser.vue'),
        }
    ]
};